const routes = [
    {
      name: 'HR_access',
      path: '/pages/HR_access',
      component: () => import('@pages/HR_access'),
    }
]

export default routes;